import { SET_FILTERED_RESULTS_COUNT } from './constants';

const setFilteredResultsCount = (count) => ({
  type: SET_FILTERED_RESULTS_COUNT,
  filteredResultsCount: count,
});

export {
  setFilteredResultsCount,
};



// WEBPACK FOOTER //
// ./src/containers/Search/actions.js